import { createContext, useContext } from "react"

export const SideNavContext = createContext({
  sideNavOpen: false,
  setSideNavOpen: () => {},
})

const { Provider } = SideNavContext

export const SideNavProvider = Provider

export function useSideNavConfig() {
  const sideNavConfig = useContext(SideNavContext)

  return sideNavConfig
}
